import { Link } from "wouter";
import { Skeleton } from "@sfc/ui";
import { Page } from "@client/components/utils/Page";
import { PageHeader } from "@client/components/utils/PageHeader";
import { cn } from "@client/utils/cn";
import { ApplicationLoading } from "@client/components/applications/ApplicationLoading";

export function TeamsLoading({
  admin,
  detail = false,
}: {
  admin: boolean;
  detail?: boolean;
}) {
  return (
    <Page
      spacing="header"
      containerClassName={detail ? "max-w-7xl" : "max-w-3xl"}
      className="flex flex-col gap-6"
    >
      <span hidden data-application-theme="green" />
      <PageHeader
        navigation={
          detail && (
            <Link
              href={admin ? "~/admin/teams" : "~/teams"}
              className="inline-flex min-h-11 items-center body-sm text-primary"
            >
              {admin ? "All Teams" : "My Teams"}
            </Link>
          )
        }
        title={detail ? undefined : admin ? "Manage Teams" : "My Teams"}
        actions={
          !detail && (
            <Skeleton
              className="h-9 w-36 max-w-full motion-reduce:animate-none"
              aria-hidden="true"
            />
          )
        }
        description={
          detail
            ? undefined
            : admin
              ? "View and manage teams across S-Process."
              : "To apply for a funding round, create a team for your organization or project. Then start an application and invite others to work on it with you. Applying on your own? Your team can be just you."
        }
      >
        {detail && (
          <>
            <Skeleton
              className="h-9 w-64 max-w-full motion-reduce:animate-none"
              aria-hidden="true"
            />
            <Skeleton
              className="h-6 w-24 motion-reduce:animate-none"
              aria-hidden="true"
            />
          </>
        )}
      </PageHeader>
      <div
        className={cn(
          "flex h-11 items-center gap-6",
          detail ? "border-b border-border" : "justify-between",
        )}
        aria-hidden="true"
      >
        <Skeleton className="h-5 w-28 motion-reduce:animate-none" />
        <Skeleton className="h-5 w-28 motion-reduce:animate-none" />
      </div>
      <ApplicationLoading
        label={detail ? "Loading team" : "Loading teams"}
        rows={2}
      />
    </Page>
  );
}
